import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteDocumentType($companyId: ID!, $id: ID!) {
    deleteDocumentType(companyId: $companyId, id: $id) {
      documentType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
